import { useEffect } from "react";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import useCancelEmployeeImportJobApiService from "../services/api/CancelEmployeeImportJobApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function CancelEmployeeImportJobHook(): {
  cancelEmployeeImportJob: (request: number) => void;
} {
  const { isSuccess, isError, mutate, error } =
    useCancelEmployeeImportJobApiService();
  const { showToast } = useToasts();
  const cancelEmployeeImportJob = (request: number): void => {
    mutate(request);
  };

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_import_upload_cancel_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      showToast({ strapiId: "employee_import_upload_cancel_success" });
      queryClient.invalidateQueries(["EmployeeImportJobListApiService"]).then();
    }
  }, [isSuccess]);

  return {
    cancelEmployeeImportJob,
  };
}
